<template lang="pug">
  article(name="component-fade" mode="out-in")
    navbar(v-bind:header-class="navbarClass")
      router-link(slot="left" v-bind:to="{ name: 'home' }")
        span.p-media-brand-icon
      span(slot="title") {{ title }}
      span(slot="right")
    .l-content
      .l-container
        .c-container

          empty-state(v-show="true" v-bind:title="'Page not found'" v-bind:message="null" v-bind:action="null" v-bind:action-text="''")
            div(slot="custumMessage")
              p
                |大変申し訳ありませんが、該当ページがございません。
                br
                router-link.u-text-underline(v-bind:to="{ name: 'home' }" replace) ホーム画面
                |へご案内いたします。
              p
                |このページをブックマーク登録されていた方は、
                br
                |お手数ですがブックマークの変更をお願いいたします。
    .l-copyright
      span {{ overview.company.copyright }}

</template>
<script>
  import { mapGetters } from 'vuex'
  import EmptyState from '../components/EmptyState.vue'

  export default {
    data () {
      return {
        navbarClass: 'c-navbar--primary c-navbar--center',
      }
    },
    title () {
      return this.title
    },
    created () {
      this.$emit('page-navbar', false)
    },
    components: {
      EmptyState
    },
    computed: {
      ...mapGetters('config', {
        overview: 'settings'
      }),
    }
  }
</script>
